/**
 * Created by Cathy on 10/08/2021.
 * Description: get credentials from server
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TransportService } from './transport.service';
import { AppConfig } from '../models/app-config.model';

@Injectable()
/** get credential from service */
export class CredentialService {
    constructor(
        private _transportService: TransportService
    ) { }

    getCredentials(): Observable<any> {
        const url = `${AppConfig.credentialEndpoint}`;
        const params = {
            outputformat: 'json'
        };
        const options = {
            params: params
        };
        return this._transportService.get(url, options);
    }
}
